import React, { ChangeEvent } from 'react';
import ManageTemplateFormItem from '../ManageTemplateFormItem';
import { TextField } from 'neon-design-system';
import { FormControl } from '../../../utils/form.utils';
import { CommonTextFieldProps } from 'neon-design-system';


interface FormTextFieldProps extends CommonTextFieldProps {
	field: FormControl<any>;
	charsLimit: number;
}

const FormTextField = ({ field, charsLimit, ...other }: FormTextFieldProps) => {
	return (
		<ManageTemplateFormItem>
			<TextField
				fullWidth
				error={field.showError}
				errorText={field.validationMessage}
				type="text"
				label={other.label}
				autoComplete="off"
				value={field.value ?? ''}
				onBlur={field.handleBlur}
				onChange={(e: ChangeEvent<any>) => {
					const val: string = e?.target?.value;
					if (val?.length > charsLimit) {
						return;
					}
					field.setValue(val);
				}}
				{...other}
			/>
		</ManageTemplateFormItem>
	);
};

export default FormTextField;
